// Maria, 19 October 2026: the cards on a page, in whole rows, from the space on the screen (see ProfilesGrid).
export const CARD_HEIGHT = 88;
export const CARD_MIN_WIDTH = 160;
export const CARD_GAP = 8;
// Maria, 30 October 2026: one more page size, eight screens of rows
export const PAGE_MULTIPLES = [1, 2, 4, 8];

// the whole columns and rows of cards that fit in the space
export const cardGrid = (width, height) => ({
    columns: Math.max(1, Math.floor((width + CARD_GAP) / (CARD_MIN_WIDTH + CARD_GAP))),
    rows: Math.max(1, Math.floor((height + CARD_GAP) / (CARD_HEIGHT + CARD_GAP)))
});

// AD-2831: where the cards start on the page, whatever the page has been scrolled to
export const cardsTop = (topInWindow, scrolledBy) => topInWindow + Math.max(0, scrolledBy || 0);

// AD-2831: where an element starts on the page, from the page layout, which does not change while the page is scrolled
// or its scroll is locked
export const pageTop = element => {
    let top = 0;
    for (let e = element; e; e = e.offsetParent) top += e.offsetTop;
    return top;
};

export const cardsOnScreen = (width, height) => {
    const {columns, rows} = cardGrid(width, height);
    return columns * rows;
};

// Maria, 27 October 2026: the page sizes are offered as rows, with three rows for anyone who wants fewer cards
// than one screen holds. The choice is 'rows' (three rows) or the number of screens.
export const FEWER_ROWS = 3;

export const rowsForChoice = (choice, screenRows) =>
    choice === 'rows' && FEWER_ROWS < screenRows
? FEWER_ROWS
        : screenRows * (choice === ALL_CHOICE ? LARGEST_MULTIPLE : Number(choice) || 1);

export const rowChoices = screenRows => [
    ...(FEWER_ROWS < screenRows ? [FEWER_ROWS] : []),
    ...PAGE_MULTIPLES.map(multiple => screenRows * multiple)
];

export const choiceForRows = (rows, screenRows) =>
    rows < screenRows ? 'rows' : String(Math.max(1, Math.round(rows / screenRows)));

export const rowsLabel = rows => (rows === 1 ? '1 row' : `${rows} rows`);

// Maria, 30 October 2026: 'All' is taken out, as it took about a minute to load on a large school. A choice of 'All'
// kept in the browser becomes the largest page size.
export const ALL_CHOICE = 'all';
export const LARGEST_MULTIPLE = PAGE_MULTIPLES[PAGE_MULTIPLES.length - 1];
export const cardsForChoice = (choice, grid) => grid.columns * rowsForChoice(choice, grid.rows);

// AD-2743: one screen ends above the line with 'Admicity © 2026' as it sits at the bottom of the window, whether or not
// the line is in view now. Measuring to where the line happens to be changed the size after each load and looped.
export const PAGE_NUMBERS_HEIGHT = 52;
export const screenBottom = (windowBottom, footerHeight) =>
    windowBottom - (footerHeight > 0 ? footerHeight : PAGE_NUMBERS_HEIGHT);

// AD-2831: closing the page size list brings the scroll bar back, which Chrome reports as a resize of the visible area
// although the window has not changed size. The page is only measured again when the window's own width or height has
// changed, so closing the list leaves the page where it was scrolled.
export const windowSize = win => ({
    width: win.innerWidth,
    height: Math.round(win.visualViewport ? win.visualViewport.offsetTop + win.visualViewport.height : win.innerHeight)
});
export const windowResized = (last, now) =>
    !last || last.width !== now.width || Math.abs(last.height - now.height) > 1;
